import React, { useEffect, useState, useMemo } from 'react'
import { Wrapper, BarStrip,  StepperItem, ProgressBar, Modal, TextAreaIcon, TextFieldIcon, FileFieldIcon } from '../_components'
import Table, { SelectColumnFilter } from '../_components/Table'
import data from '../fixtures'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import Axios from 'axios'
import moment from 'moment'

const steps = [
  "Actioned"
]

const RegeneratePRNField = record => {

    const handleClick = async id => {
        await localStorage.setItem( "applicationId", id )
        await localStorage.setItem( "link", "display")
        window.location.reload()
    }

    // incomplete applications with generated PNRs
    return (
        ((record.row.original.prn_status === "EXPIRED")) && 
        (<div onClick={async () => {
          //add check if payment_reference_number is expired and action below 
          let application_id = record.row.original.id
          try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/re_generate_payment_slip_for_client/${application_id}` )
            if( response.data ){
              //setCircularLoading(true)
              alert(response.data.message)
              await localStorage.setItem( "link", "generated_prns" )
              return window.location.reload()
            }
          } catch (error) {}
        }} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 px-3 rounded bg-[#3669c8] text-xs text-white flex items-center justify-center">
        {`Regenerate PRN`}
      </div> )
    )
}

export default function GeneratedPRNs( ) {

  const ApplicationColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Trading Name",
      accessor: "applicant"
    },
    {
      Header: "Entity Name",
      accessor: "entity_name"
    },
    {
        Header: "Date Updated",
        accessor: "date_updated"
    },
    {
        Header: "Contact Person",
        accessor: "contact_person"
    },
    {
        Header: "Mobile No",
        accessor: "phone_number"
    },
    {
        Header: "Fees to Pay",
        accessor: "certification_fees_to_pay",
    },
    {
        Header: "PRN",
        accessor: "prn",
    },
    {
        Header: "Actions",
        accessor: "id",
        Cell: RegeneratePRNField
    }
  ] )

  const dispatch = useDispatch()
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ showModal, setShowModal ] = useState( false )
  const [ tag, setTag ] = useState( "Pending" )
  const [ grandTotal, setGrandTotal ] = useState( 0 )
  const state = useSelector( state => {
    return {
      id: state.application.verifyModal?.id,
      displayModal: state.application.verifyModal?.display,
      record: state.application.verifyModal?.record,
    }
  } )

  useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const handleResults = ( values ) => {

    if(localStorage.getItem( "role" )?.toUpperCase().includes("FINANCE")){
        return values.filter( item => (item.verify_status?.toLowerCase() === "completed" && item.prn !== null) )
    }
  }

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
        var fees_to_pay_sum = 0;
        const results = response.data.map( ( result, index ) => {
          fees_to_pay_sum += (result.certification_fees_to_pay != null) ? parseInt(result.certification_fees_to_pay) : 0
          return {
            recordId: `${index+1}`,
            sno: result.serial_number,
            progress: result.progress,
            applicant: result.trading_name,
            entity_name: result.entity_name, 
            date_updated: moment( result.updated_at ).format( "DD MMM, YYYY" ),
            contact_person: `${result.contact_first_name || ""} ${result.contact_last_name || ""}`,
            designation: result.designation,
            email_id: result.created_by,
            phone_number: result.contact_phone_number,
            verify_status: result.verification_status || "Pending",
            updated_at: result.updated_at,
            id: result.id,
            report: "",
            stage: result.stage,
            prn: result.payment_reference_number,
            prn_status: result.prn_status,
            certification_fees_to_pay: result.certification_fees_to_pay
          }
        }).sort( ( a, b ) => {
          return moment( b.updated_at ).format( "YYYYMMDDHHMM" ) - moment( a.updated_at ).format( "YYYYMMDDHHMM" )
        })
        setRecords( results )
        console.log(fees_to_pay_sum)
        setGrandTotal( fees_to_pay_sum )
        setLoading( false )
      }
    } catch (error) {
      console.log("failed to fetch applications for finance")
      alert( "Server error occurred." )
      setLoading( false )
    }
  }

  const numberWithCommas = (numberToFormat) => {
    return numberToFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip title={`Applications for finance to review`} />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`List of all generated PRNs`}
            </div>

            <div className="flex flex-col items-start justify-center w-full bg-white">
              <div className="flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
              </div>
              <Table 
                label="Application Details"
                columns={ApplicationColumns}
                data={handleResults( records )}
                hidePagination={false}
              />
              <div>Total Fees to pay: {numberWithCommas(grandTotal)}/=</div>
            </div>

          </div>
        </div>
    </Wrapper>
  )
}
